import { convertNumbers } from "../../utils/ConvertNumbers";
import PersonIcon from "@material-ui/icons/Person";
import Speed from "@material-ui/icons/Speed";
import Button from "@material-ui/core/Button";
import InfoIcon from "@material-ui/icons/Info";
import { Grid, Typography } from "@material-ui/core";
import UserImg from "../../assets/img/user-avatar.png";
import CardContent from "@material-ui/core/CardContent";
import { Card } from "@material-ui/core";
import PhoneEnabledIcon from "@material-ui/icons/PhoneEnabled";
import { useHistory } from "react-router";

const User = (props) => {
  const image = UserImg;

  const history = useHistory();

  const goToUserDetails = (e) => {
    history.push("/admin/users/" + props.data.id);
  };

  const renderDetails = () => {
    if (props.renderDetails) {
      return (
        <Grid
          style={{
            fontSize: "14px",
            color: "#73879c",
            paddingTop: "16px",
          }}
          container
          direction="row"
          alignItems="center"
        >
          <Grid item sx={12} sm={12} md={12} lg={12}>
            <Button
              onClick={goToUserDetails}
              style={{
                width: "100%",
                color: "#1976d2",
              }}
              variant="outlined"
              endIcon={<InfoIcon />}
            >
              جزئیات بیشتر
            </Button>
          </Grid>
        </Grid>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      <Grid
        style={{ paddingRight: "8px", paddingLeft: "8px", paddingTop: "40px" }}
        item
        sx={12}
        sm={4}
        md={3}
        lg={2}
      >
        <Card
          align="center"
          style={{ marginBottom: "16px", overflow: "visible" }}
        >
          <img
            src={image}
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              marginTop: "-30px",
            }}
            alt="counter-type"
          />
          <CardContent>
            <Typography align="center" style={{ fontWeight: "bold" }}>
              {convertNumbers(props.data.name)}
            </Typography>
            <div
              style={{
                height: "16px",
                borderBottom: "1px solid #e6e9ed",
                marginBottom: "16px",
              }}
            ></div>
            <Grid
              style={{ fontSize: "14px", color: "#73879c" }}
              container
              direction="row"
              alignItems="center"
            >
              <Grid style={{ marginLeft: "2px" }} item>
                <PhoneEnabledIcon />
              </Grid>
              <Grid item>{convertNumbers(props.data.phoneNumber)}</Grid>
            </Grid>

            <Grid
              style={{ fontSize: "14px", color: "#73879c" }}
              container
              direction="row"
              alignItems="center"
            >
              <Grid style={{ marginLeft: "2px" }} item>
                <Speed />
              </Grid>
              <Grid item>
                <span>{convertNumbers(props.data.counters)}</span>
                <span> کنتور </span>
              </Grid>
            </Grid>

            {renderDetails()}
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default User;
